export const SET_CURRENT_CUSTOMER = 'waldur/workspace/SET_CUSTOMER';
export const SET_CURRENT_PROJECT = 'waldur/workspace/SET_PROJECT';
export const SET_CURRENT_USER = 'waldur/workspace/SET_USER';
export const SET_IMPERSONATOR_USER = 'waldur/workspace/SET_IMPERSONATOR_USER';
export const SET_CURRENT_RESOURCE = 'waldur/workspace/SET_RESOURCE';
